import React, { Fragment } from 'react';
import _ from 'lodash';

export const getTimeDisplayFromNumber = (time) => {
  const { minutes, seconds } = getTimeComponentsFromNumber(time);
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};
export const getPrettyTimeDisplayFromNumber = (time) => {
  const { minutes, seconds } = getTimeComponentsFromNumber(time);
  if (minutes >= 3) {
    return `${_.round(minutes)} min`;
  } else if (minutes) {
    return `${_.round(minutes)} min ${seconds} s`;
  }
  return `${seconds}s`;
};

export const getPrettyFileSize = (file) => {
  if (file.size > 1e6) return `${(file.size / 1e6).toFixed(1)} MB`;
  if (file.size > 1e3) return `${(file.size / 1e3).toFixed(0)} KB`;
  return `${file.size.toFixed(1)} BYTES`;
};
export const getPrettyTimeDisplayFromTimestamp = (timestamp) => {
  /*
    0:00:00 > 0:00
    0:05:10 > 5:10
  */
  const [hour, minute, seconds] = timestamp.split(':');
  return `${parseInt(hour) * 60 + parseInt(minute)}:${seconds}`;
};
export const getSecondsFromTimestamp = (timestamp) => {
  const [hour, minute, seconds] = timestamp.split(':');
  return parseInt(hour) * 60 * 60 + parseInt(minute) * 60 + parseInt(seconds);
};
export const getTimeComponentsFromNumber = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return {
    minutes,
    seconds,
  };
};

export const formatEmotion = (emotion) => {
  return {
    lowercase: emotion.toLowerCase(),
    uppercase: emotion.toUpperCase(),
    titleCase: emotion.charAt(0).toUpperCase() + emotion.slice(1),
  };
};

export const getActionItemsFromCall = (items) =>
  _.filter(items, (part) => part.length > 2)
    .join('')
    .split('-');

export const formatActionItemsFromCall = (items) =>
  getActionItemsFromCall(items).map((a, idx) =>
    a && a.length ? (
      <Fragment key={idx}>
        • <span>{a}</span>
        <br />
      </Fragment>
    ) : (
      ''
    )
  );

export const getUrlParameter = (param) => new URLSearchParams(document.location.search).get(param);

export const removeUrlParameter = (param) =>
  window.history.pushState(
    null,
    '',
    window.location.pathname + window.location.search.replace(new RegExp(`[?&]${param}=[^&]+`), '').replace(/^&/, '?')
  );
export const getInitials = (name) => {
  const parts = name.split(' ');
  if (parts.length === 1) return name[0].toUpperCase();
  return name[0].toUpperCase() + _.last(parts)[0].toUpperCase();
};

export const getAdjustedName = (name) => {
  if (name.includes('spk_')) {
    const number = parseInt(name.replace('spk_', ''));
    return `Speaker ${number + 1}`;
  }
  return name;
};
